import { citypasswordConstants } from '../constants/citypasswordConstants';
import { citypasswordService } from '../../services/API/citypasswordService';
import { history }              from '../store/configureStore';

export const  addCityPassword = (postData) => {
  return dispatch => {
    citypasswordService.addCityPassword(postData)
    .then(
      data => { 
        dispatch(success(data));
      },
     
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) { return { type: citypasswordConstants.ADD_CITYPASSWORD_REQUEST, data } }
  function success(data) { return { type: citypasswordConstants.ADD_CITYPASSWORD_SUCCESS, data } }
  function failure(error) { return { type: citypasswordConstants.ADD_CITYPASSWORD_FAILURE, error } }
}

export const getCityPasswordList = (postData) => {
  return dispatch => {
    citypasswordService.getCityPasswordList(postData)
    .then(
      data => { 
        dispatch(success(data));
      },
     
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) { return { type: citypasswordConstants.GET_CITYPASSWORD_REQUEST, data } }
  function success(data) { return { type: citypasswordConstants.GET_CITYPASSWORD_SUCCESS, data } }
  function failure(error) { return { type: citypasswordConstants.GET_CITYPASSWORD_FAILURE, error } }
}

export const  deleteCityPassword = (citypasswordID) => {
  return dispatch => {
    citypasswordService.deleteCityPassword(citypasswordID)
    .then(
      data => { 
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) { return { type: citypasswordConstants.DELETE_CITYPASSWORD_REQUEST, data } }
  function success(data) { return { type: citypasswordConstants.DELETE_CITYPASSWORD_SUCCESS, data } }
  function failure(error) { return { type: citypasswordConstants.DELETE_CITYPASSWORD_FAILURE, error } }
}

export const  citypasswordStatus = (citypasswordID) => {
  return dispatch => {
    citypasswordService.citypasswordStatus(citypasswordID)
    .then(
      data => { 
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) { return { type: citypasswordConstants.STATUS_CITYPASSWORD_REQUEST, data } }
  function success(data) { return { type: citypasswordConstants.STATUS_CITYPASSWORD_SUCCESS, data } }
  function failure(error) { return { type: citypasswordConstants.STATUS_CITYPASSWORD_FAILURE, error } }
}


export const getCityPasswordDetail = (citypasswordID) => {
  return dispatch => {
    citypasswordService.getCityPasswordDetail(citypasswordID)
    .then(
      data => { 
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) { return { type: citypasswordConstants.GET_CITYPASSWORDDETAIL_REQUEST, data } }
  function success(data) { return { type: citypasswordConstants.GET_CITYPASSWORDDETAIL_SUCCESS, data } }
  function failure(error) { return { type: citypasswordConstants.GET_CITYPASSWORDDETAIL_FAILURE, error } }
}

export const  updateCityPassword = (postData) => {
  return dispatch => {
    citypasswordService.updateCityPassword(postData)
    .then(
      data => { 
        dispatch(success(data));
      },
     
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) { return { type: citypasswordConstants.ADD_CITYPASSWORD_REQUEST, data } }
  function success(data) { return { type: citypasswordConstants.ADD_CITYPASSWORD_SUCCESS, data } }
  function failure(error) { return { type: citypasswordConstants.ADD_CITYPASSWORD_FAILURE, error } }
}




// WEBPACK FOOTER //
// ./src/app/redux/actions/citypasswordActions.js